module.exports = {
  defaultLocale: 'en', // Default language of your website
  locales: ['en'], // Array with the languages that you want to use
  pages: {
    '*': ['common', 'buyersHomepage', 'suppliersHomepage', 'superadmin'],
  },
};
